import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { SNOWPLOW_EVENTS } from '../../analytics.const';

import {
	VEHICLE_DETAILS_IMAGE_EVENTS,
	VEHICLE_DETAILS_IMAGE_SECTIONS,
	VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS,
} from './galleryEvents.consts';
import type { ZoomEventsParams } from './galleryEvents.types';

export const triggerZoomInImageEvent = ({ maxZoom = 3, section, zoomLevel }: ZoomEventsParams): void => {
	const zoomLevelLabel =
		zoomLevel > maxZoom
			? VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS.ANOTHER_LEVEL
			: VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS[`LEVEL_${zoomLevel}`];

	const snowplowEventPayload = getSnowplowEventPayload({
		category: VEHICLE_DETAILS_IMAGE_SECTIONS[section],
		customData: { label: zoomLevelLabel },
		name: VEHICLE_DETAILS_IMAGE_EVENTS.ZOOM_IN.snowplow,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload: snowplowEventPayload });
};
